import { render, staticRenderFns } from "./EditBoardModalComponent.vue?vue&type=template&id=995cd66c&"
import script from "./EditBoardModalComponent.vue?vue&type=script&lang=ts&"
export * from "./EditBoardModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('995cd66c')) {
      api.createRecord('995cd66c', component.options)
    } else {
      api.reload('995cd66c', component.options)
    }
    module.hot.accept("./EditBoardModalComponent.vue?vue&type=template&id=995cd66c&", function () {
      api.rerender('995cd66c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/Board/EditBoardModalComponent.vue"
export default component.exports